import { useMemo } from "react";
import { useProfiles } from "../profiles.js";
import { TreasuryClient, TwinClient } from "./client.js";
import { useQuery } from "@tanstack/react-query";

export function getClient({client} = {}) {
  if (client) {
    return new TwinClient(client);
  }
}

export function getActiveClient() {
  const { getActiveProfile } = useProfiles();
  return getClient(getActiveProfile())
}

/**
 *
 * @returns {TwinClient}
 */
export function useActiveClient() {
  let { active, getActiveProfile } = useProfiles();
  let client = useMemo(() => getClient(getActiveProfile()), [active]);
  return client;
}

export function useTreasuryClient() {
  let twin = useActiveClient();
  let treasury = TreasuryClient.from(twin);
  let { data: treasuryConfig } = useQuery({
    queryKey: [ "GET", treasury.url, "/" ],
    queryFn: async () => {
      return await treasury.getConfig();
    },
    refetchOnWindowFocus: "always",
    refetchOnMount: "always",
    refetchOnReconnect: "always",
  });
  treasury.setConfig(treasuryConfig);
  // HAAACK(sfertman): need to apply this explicitly so that React knows this object also depends on the query result and updates UI accordingly.

  return treasury;

}